import HttpService from './baseHttp'

// 获取14天销售数据
export const HttpGetSalenData = (data = {}, config) => HttpService.get('/api/v1/overview/getSaleInformation', { params: data, baseURL: process.env.VUE_APP_APIURL_BOSS })

// 获取销售额，订单总数量
export const HttpGetSales = (data = {}, config) => HttpService.get('/api/v1/overview/getSales', { params: data, baseURL: process.env.VUE_APP_APIURL_BOSS })

// 获取未发货订单
export const HttpGetPending = (data = {}, config) => HttpService.get('/api/v1/overview/getPending', { params: data, baseURL: process.env.VUE_APP_APIURL_BOSS })

// 公告列表
export const HttpGetAnnouncement = (data = {}, config) => HttpService.get('/api/v1/Announcement/findByPage', { params: data, baseURL: process.env.VUE_APP_APIURL_BOSS })


// 圆形的获取接口
// 获取库存分布情况
export const HttpInventoryProportion = (data = {}, config) => HttpService.post('/api/v2/inventory/list/inventoryProportion', data, { params: { contextId: global.SYSID },baseURL: process.env.VUE_APP_APIURL_FBB })
// 获取账户提醒
// export const HttpAccountStat = (data = {}, config) => HttpService.post('/api/v2/funding/accountAmount/accountStat', data, { params: { contextId: global.SYSID },baseURL: process.env.VUE_APP_APIURL_FBB })

// 总退货单
export const HttpGetReturn = (data = {}, config) => HttpService.get('/api/v1/overview/getReturn', { params: data, baseURL: process.env.VUE_APP_APIURL_BOSS })

// 保存ebay的接口
export const HttpSaveEbayFlag = (data = {}, config) => HttpService.get('/api/v1/Account/getAuthorizeUrl', { params: data, baseURL: process.env.VUE_APP_APIURL_BOSS })







